import { gql } from '@apollo/client';

export const UPDATE_PATIENT_ADDRESS = gql`
  mutation updatePatientAddress($addressInput: AddressInput!) {
    updatePatientAddress(addressInput: $addressInput)
  }
`;
